"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperationType;
(function (OperationType) {
    OperationType["Mutation"] = "mutation";
    OperationType["Query"] = "query";
    OperationType["Subscription"] = "subscription";
})(OperationType || (OperationType = {}));
exports.default = OperationType;
//# sourceMappingURL=OperationType.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/gql-query-builder/build/OperationType.js
// module id = 235
// module chunks = 2